import { render, staticRenderFns } from "./TheInvestmentsAssets.vue?vue&type=template&id=5df35195&"
import script from "./TheInvestmentsAssets.vue?vue&type=script&lang=js&"
export * from "./TheInvestmentsAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports